import { createContext } from 'react';

const ArtlistDataContext = createContext(0);

export default ArtlistDataContext;